export default "__VITE_ASSET__BMuppkMP__"